var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, ViewChild } from '@angular/core';
import { appModuleAnimation } from '../../animations/routerTransition';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { finalize } from 'rxjs/operators';
var RawAlarmRegistrationComponent = /** @class */ (function (_super) {
    __extends(RawAlarmRegistrationComponent, _super);
    function RawAlarmRegistrationComponent(injector, fBoxAlarmRegistrationService, dataTypeService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.fBoxAlarmRegistrationService = fBoxAlarmRegistrationService;
        _this.dataTypeService = dataTypeService;
        return _this;
    }
    RawAlarmRegistrationComponent.prototype.ngAfterViewInit = function () {
        this.alreadyAfterViewInit = true;
        this.loadFBoxAlarmData();
    };
    RawAlarmRegistrationComponent.prototype.ngOnChanges = function (changes) {
        if (this.alreadyAfterViewInit) {
            this.loadFBoxAlarmData();
        }
    };
    RawAlarmRegistrationComponent.prototype.loadFBoxAlarmData = function () {
        this.loadFBoxAlarmGroupNames();
        this.loadFBoxAlarms();
    };
    RawAlarmRegistrationComponent.prototype.loadFBoxAlarmGroupNames = function () {
        var _this = this;
        this.fBoxAlarmRegistrationService.getRefAlarmGroupNames(this.dataSourceId)
            .subscribe(function (result) { return _this.groupNames = result.map(function (x) { return x.groupName; }); });
    };
    RawAlarmRegistrationComponent.prototype.loadFBoxAlarms = function (event) {
        var _this = this;
        if (this.dataSourceId === undefined) {
            return;
        }
        this.primengTableHelper.showDelayLoadingIndicator();
        this.fBoxAlarmRegistrationService.getFBoxAlarms(this.dataSourceId, this.fBoxAlarmName, this.selectedGroupName, this.primengTableHelper.getSorting(this.dataTable), this.primengTableHelper.getMaxResultCount(this.paginator, event), this.primengTableHelper.getSkipCount(this.paginator, event)).pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
            .subscribe(function (result) {
            _this.primengTableHelper.requestCompleted = true;
            _this.primengTableHelper.totalRecordsCount = result.totalCount;
            _this.primengTableHelper.records = result.items;
        });
    };
    RawAlarmRegistrationComponent.prototype.formatConditionType = function (record) {
        var isBit = false;
        if (record.dataType === 0 || record.bitIndexEnabled) {
            isBit = true;
        }
        if (isBit && record.operand1 === 0) {
            return 'OFF';
        }
        if (isBit && record.operand1 === 1) {
            return 'ON';
        }
        if (!isBit) {
            switch (record.conditionCombineMethod) {
                case 0:
                    return this.lc('Value') + ' ' + this.convertCondition(record.condition1) + record.operand1;
                case 1:
                    return this.lc('Value') + ' ' + this.convertCondition(record.condition1) +
                        record.operand1 + this.lc('And') + this.convertCondition(record.condition2) + record.operand2;
                case 2:
                    return this.lc('Value') + ' ' + this.convertCondition(record.condition1) +
                        record.operand1 + this.lc('Or') + this.convertCondition(record.condition2) + record.operand2;
            }
        }
    };
    RawAlarmRegistrationComponent.prototype.formatDataType = function (dataType, bitIndexEnabled) {
        var _this = this;
        return this.dataTypeService.formatDataType(dataType, bitIndexEnabled, function (key) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return _this.lc.apply(_this, [key].concat(args));
        });
    };
    RawAlarmRegistrationComponent.prototype.convertCondition = function (condition) {
        switch (condition) {
            case 0:
                return this.lc('NotEqualTo');
            case 1:
                return this.lc('EqualTo');
            case 2:
                return this.lc('GreaterThan');
            case 3:
                return this.lc('GreaterThanOrEqualTo');
            case 4:
                return this.lc('LessThan');
            case 5:
                return this.lc('LessThanOrEqualTo');
        }
    };
    __decorate([
        Input()
    ], RawAlarmRegistrationComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], RawAlarmRegistrationComponent.prototype, "dataSourceId", void 0);
    __decorate([
        ViewChild('dataTable', { static: true })
    ], RawAlarmRegistrationComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], RawAlarmRegistrationComponent.prototype, "paginator", void 0);
    RawAlarmRegistrationComponent = __decorate([
        Component({
            selector: 'raw-alarm-registration',
            template: " <div class=\"portlet-input\"> <div class=\"row variable-search\"> <div class=\"col-xl-2\"> <div class=\"input-group\"> <input placeholder='{{lc(\"SearchAlarmName\")}}' type=\"text\" name=\"fBoxAlarmName\" [(ngModel)]=\"fBoxAlarmName\" (change)=\"loadFBoxAlarms()\"/> <i class=\"fcloud-search\" (click)=\"loadFBoxAlarms()\"></i> </div> </div> <div class=\"col-xl-2\"> <div class=\"input-group\"> <select (change)=\"loadFBoxAlarms()\" name=\"groupName\" [(ngModel)]=\"selectedGroupName\"> <option [ngValue]=\"undefined\" selected>{{lc(\"AllGroup\")}}</option> <option *ngFor=\"let groupName of groupNames\" [value]=\"groupName\"> {{groupName}} </option> </select> </div> </div> </div> </div> <div class=\"primeng-datatable-container\" [busyIf]=\"primengTableHelper.isLoading\"> <p-table #dataTable (onLazyLoad)=\"loadFBoxAlarms($event)\" [value]=\"primengTableHelper.records\" rows=\"{{primengTableHelper.defaultRecordsCountPerPage}}\" [paginator]=\"false\" [lazy]=\"true\" scrollable=\"true\" ScrollWidth=\"100%\" responsive=\"primengTableHelper.isResponsive\" resizableColumns=\"primengTableHelper.resizableColumns\"> <ng-template pTemplate=\"header\"> <tr> <th class=\"col-md-1 col-xs-1\"> {{lc('AlarmNameG')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('AlarmMessage')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('AlarmConditionType')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('DataType')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('Address')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('Devices')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('StationNo')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('GroupName')}} </th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-record> <tr> <td> {{record.name}} </td> <td> {{record.alarmMessage}} </td> <td> {{formatConditionType(record)}} </td> <td> {{formatDataType(record.dataType, record.bitIndexEnabled)}} </td> <td> {{record.addressDescription}} </td> <td> {{record.devAlias}} </td> <td> {{record.stationNo}} </td> <td> {{record.groupName}} </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"primengTableHelper.totalRecordsCount == 0\"> {{l('NoData')}} </div> <div class=\"primeng-paging-container\"> <p-paginator #paginator [rows]=\"primengTableHelper.defaultRecordsCountPerPage\" (onPageChange)=\"loadFBoxAlarms($event)\" [totalRecords]=\"primengTableHelper.totalRecordsCount\" [rowsPerPageOptions]=\"primengTableHelper.predefinedRecordsCountPerPage\"> </p-paginator> <span class=\"total-records-count\"> {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}} </span> </div> </div> ",
            animations: [appModuleAnimation()]
        })
    ], RawAlarmRegistrationComponent);
    return RawAlarmRegistrationComponent;
}(ConfigureComponentBase));
export { RawAlarmRegistrationComponent };
